import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../../store/api/rx-factory'
import * as Enpoints from '../../../../../store/api/endpoints'
import moment from 'moment'

export const actions = {
	// Download commission list
	[Const.RUN_DOWNLOAD_COMMISSION_LIST_FILE]({commit, state,getters,dispatch}, credentials){	
		let API = Enpoints.EP_COMMISSION_LIST_DOWNLOAD
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.csvExport(result.res_data , 'commission-list-data.csv')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_COMMISSION_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_COMMISSION_LIST_DOWNLOAD,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			credentials.localParams.parameter.innerPageLoader = false
			if(!error){
				commit(Const.SET_COMMISSION_LIST,result.res_data)
			}else{
				commit(Const.SET_COMMISSION_LIST, {})
			}
		})
  	},
	// CALL VOISO api
	[Const.RUN_CLICK_2_CALL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CLICK_2_CALL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'Success','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	// EndCALL VOISO api
	[Const.RUN_CLICK_2_ENDCALL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CLICK_2_ENDCALL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'Success','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	// Download Trading Accout list
	[Const.RUN_TRADING_ACCOUNT_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TRADING_ACCOUNT_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.csvExport(result.res_data , 'trading-account-list.csv')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	//RUN_SET_MARKET_HOLIDAYS
	[Const.RUN_SET_MARKET_HOLIDAYS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_UPLOAD_MARKET_HOLIDAYS,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			console.log("1success",error)
			console.log("2success",result)
			// if(!error){
			// 	_messageDisplayFunction(credentials.localParams.parameter,'File Uploaded successfully','success')
			// }else{
			// 	_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			// }
		})
	},
	//get client Login token
	[Const.RUN_UPLOAD_HELP2PAY_PRICE]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_UPLOAD_HELP2PAY_PRICE,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if (credentials.localParams.module === 'korapay_file_upload') {
					credentials.localParams.parameter.clear_doc();
				}
				_messageDisplayFunction(credentials.localParams.parameter,'File Uploaded successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	
	//get user token
	[Const.RUN_GET_CLIENT_TOKEN]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_CLIENT_LOGIN_TOKEN,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let tokenURL= result.res_data
				window.open(`${Enpoints.CLIENT_PORTAL_URL}?auth=${result.res_data}&fromAdmin=${true}`,'_blank')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	//get IB user token
	[Const.RUN_GET_IB_LOGIN_TOKEN]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_IB_LOGIN_TOKEN,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let tokenURL= result.res_data
				window.open(`${Enpoints.IB_PORTAL_URL}?auth=${result.res_data}`,'_blank')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	//upload receipt====
	[Const.RUN_UPLOAD_RECEIPT]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_UPLOAD_RECEIPT, credentials, credentials.localParams.parameter, {'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'Success','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_UPDATE_WITHDRAWAL_COMMENT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_UPDATE_WITHDRAWAL_COMMENT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'Comment Updated successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_UPDATE_DEPOSIT_COMMENT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_UPDATE_DEPOSIT_COMMENT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create withdrawal successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	// [Const.RUN_TRADING_ENABLE_DISABLE]({commit, state, dispatch,getters}, credentials){
	// 	_executeApi(Enpoints.EP_TRADING_ENABLE_DISABLE,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
	// 		if(!error){
	// 			credentials.localParams.parameter.updateItem = {}
	// 			_messageDisplayFunction(credentials.localParams.parameter,`Trading Account ${credentials.globalParams.status == 1?'Disabled':'Enabled'} successfully`,'success')
	// 			credentials.localParams.parameter.listing()
	// 		}else{
	// 			_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
	// 		}
	// 	})
  	// },
	[Const.RUN_DISABLE_TRADING_ACCOUNT]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_DISABLE_TRADING_ACCOUNT,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.disableItem = {}
				credentials.localParams.parameter.listing()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_DELETE_TRADING_ACCOUNT]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_DELETE_TRADING_ACCOUNT,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.deleteItem = {}
				credentials.localParams.parameter.listing()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_LOCK_TRANSECTION]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_LOCK_TRANSECTION,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.lockWithDraw = {}
				_messageDisplayFunction(credentials.localParams.parameter,"Transaction locked successfully",'success')
				credentials.localParams.parameter.listing()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_GET_CLIENT_DATA]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_CLIENT_DATA,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.setUpFxaccountDP1 = false
				commit(Const.SET_CLIENT_DATA, result.res_data)
			}else{
				commit(Const.SET_CLIENT_DATA, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_BULK_UPDATE_RM_ACCURACY]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_BULK_UPDATE_RM_ACCURACY,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.listing()
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,"Rm Accuracy Update Successfully",'success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[Const.RUN_GET_CITIES_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_CITIES_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CITIES_LIST, result.res_data)
			}else{
				commit(Const.SET_CITIES_LIST,[])
			}
		})
	},
	[Const.RUN_GET_LOYALITY_TRANSACTION_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_LOYALITY_TRANSACTION_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOYALITY_TRANSACTION_LIST, result.res_data)
				if(credentials.localParams.downloadReport != undefined && credentials.localParams.downloadReport == 'downloadReport'){
					_downloadReport(result.res_data.records,'transaction-list.csv','transaction')
				}
			}else{
				commit(Const.SET_LOYALITY_TRANSACTION_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_GET_LOYALITY_CARD_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_LOYALITY_CARD_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOYALITY_CARD_LIST, result.res_data)
				if(credentials.localParams.downloadReport != undefined && credentials.localParams.downloadReport == 'downloadReport'){
					_downloadReport(result.res_data.records,'card-list.csv', 'card')
				}
			}else{
				commit(Const.SET_LOYALITY_CARD_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_VPS_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_VPS_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_VPS_LIST, result.res_data)
			}else{
				commit(Const.SET_VPS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_SUBSCRIPTION_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_SUBSCRIPTION_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_SUBSCRIPTION_LIST, result.res_data)
				}
			}else{
				commit(Const.SET_SUBSCRIPTION_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_SUBSCRIPTION_DETAIL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_SUBSCRIPTION_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_SUBSCRIPTION_DETAIL, result.res_data[0])
			}else{
				commit(Const.SET_SUBSCRIPTION_DETAIL, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_USER_SUBSCRIPTION_END]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_SUBSCRIPTION_END, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.listing()
				_messageDisplayFunction(credentials.localParams.parameter,'Subscription delete successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_USER_SUBSCRIPTION_UPDATE_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_SUBSCRIPTION_UPDATE_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//credentials.localParams.parameter.listing()
				if(credentials.localParams.filter && credentials.localParams.filter == 'no'){
					credentials.localParams.parameter.$router.push({name :'client.clientView',query:{'id':(credentials.localParams.hasOwnProperty('userid'))?credentials.localParams.userid : '','pagename':'subscribe'}})
				}else if(credentials.localParams.filter && credentials.localParams.filter == 'yes'){
					credentials.localParams.parameter.$router.push('/subscription-list')
				}
				_messageDisplayFunction(credentials.localParams.parameter,'Subscription account update successfully','success')
				
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_USER_OTHER_DETAILS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_OTHER_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_USER_OTHER_DETAILS, result.res_data)
			}else{
				commit(Const.SET_USER_OTHER_DETAILS, {})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

	[Const.RUN_UPLOAD_DOCUMENT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_UPLOAD_DOCUMENT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$refs.documentfile.value = ''
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'upload report successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_UPLOAD_DOCUMENT_PIP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_UPLOAD_DOCUMENT_PIP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$refs.pipdocumentfile.value = ''
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'upload report successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

	[Const.RUN_ADD_WEBINAR]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_WEBINAR, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'Add webinar successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_CREATE_TUT_COURSE]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_TUT_COURSE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				let inputJson = {
                    'globalParams' : {
                    } ,'localParams' : {'parameter' : credentials.localParams.parameter}
                }
				dispatch(Const.RUN_GET_TUT_COURSE,inputJson)
				_messageDisplayFunction(credentials.localParams.parameter,'Create tutorial course successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_GET_TUT_COURSE]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_TUT_COURSE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TUT_COURSE, result.res_data)
			}else{
				commit(Const.SET_TUT_COURSE, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_CREATE_TUT_CAT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_TUT_CAT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				let inputJson = {
                    'globalParams' : {                    	
                    } ,'localParams' : {'parameter' : credentials.localParams.parameter}
                }
				dispatch(Const.RUN_GET_TUT_CAT,inputJson)
				_messageDisplayFunction(credentials.localParams.parameter,'Create tutorial category successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_GET_TUT_CAT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_TUT_CAT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TUT_CAT, result.res_data)
			}else{
				commit(Const.SET_TUT_CAT, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_CREATE_TUTORIAL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_TUTORIAL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				let inputJson = {
                    'globalParams' : {                   	
                    } ,'localParams' : {'parameter' : credentials.localParams.parameter}
                }
				dispatch(Const.RUN_GET_TUTORIAL_LIST,inputJson)
				_messageDisplayFunction(credentials.localParams.parameter,'Create tutorial successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_GET_TUTORIAL_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_TUTORIAL_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TUTORIAL_LIST, result.res_data)
			}else{
				commit(Const.SET_TUTORIAL_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	//------------------------trading education-----------------------------------

  	[Const.RUN_ADD_CATEGORY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_CATEGORY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'Add category successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_POST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_POST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'Add post successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_CATEGORY_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_CATEGORY_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CATEGORY_LIST, result.res_data)
			}else{
				commit(Const.SET_CATEGORY_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_POST_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_POST_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_POST_LIST, result.res_data)
			}else{
				commit(Const.SET_POST_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},


	
	[Const.RUN_GET_DASHBOARD_DATA]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DASHBOARD_DATA, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.dashboardData =  result.res_data
			}else{
				credentials.localParams.parameter.dashboardData =  {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_DASHBOARD_OTHER_DATA]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DASHBOARD_OTHER_DATA, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.dashboardOtherData =  result.res_data
			}else{
				credentials.localParams.parameter.dashboardOtherData =  {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_TOTAL_CLIENT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TOTAL_CLIENT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.totalclient =  result.res_data
			}else{
				credentials.localParams.parameter.totalclient =  {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_DOWNLOAD_DEPOSIT_FILE]({commit, state,getters,dispatch}, credentials){	
		let API = Enpoints.EP_DOWNLOAD_DEPOSIT_FILE
		if(credentials.localParams.Page && credentials.localParams.Page == 'IB-VIEW'){
			API = Enpoints.EP_DOWNLOAD_IB_DEPOSIT_FILE
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.csvExport(result.res_data , 'deposit-list-data.csv')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_DOWNLOAD_WITHDRAWAL_FILE]({commit, state,getters,dispatch}, credentials){	
  		let API = Enpoints.EP_DOWNLOAD_WITHDRAWAL_FILE
		if(credentials.localParams.Page && credentials.localParams.Page == 'IB-VIEW'){
			API = Enpoints.EP_DOWNLOAD_IB_WITHDRAWAL_FILE
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.csvExport(result.res_data , 'withdrawal-list-data.csv')
				
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_CLIENT_REPORT]({commit, state,getters,dispatch}, credentials){	
		let API = Enpoints.EP_GET_CLIENT_REPORT
		if(credentials.localParams.page && credentials.localParams.page == 'IB-LIST'){
			API = Enpoints.EP_GET_IB_REPORT
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//console.log('result.res_data.fileName==',result.res_data.fileName)
				//let with_doc_link = getters[Const.GET_CLIENT_REPORT_LINK];
				if(credentials.localParams.page && credentials.localParams.page == 'IB-LIST'){
					const csvRows = [];
					const headers = Object.keys(result.res_data[0]);
					csvRows.push(headers.join(','));
					for (const row of result.res_data) {
						const values = headers.map(header =>  `"${row[header]}"` );
						csvRows.push(values.join(','));
					}
					let j = document.createElement("a")
					j.download = "IB_LIST_"+Date.now()+".csv"
					j.href = URL.createObjectURL(new Blob([csvRows.join('\n')]))
					j.click() 
				}else{
					let url = credentials.localParams.parameter.$env_var.clientReportLink+result.res_data.fileName ;
					console.log('url==',url)
					window.open(url,'_blank');
				}
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ALL_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ALL_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.internalNotes = result.res_data
			}else{
				credentials.localParams.parameter.internalNotes = {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},


  	[Const.RUN_CHANGE_PASSWORD]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'Password Change Successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})  
  	},
  	[Const.RUN_GET_CHART_DATA]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_CHART_DATA, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.csvData = result.res_data
				credentials.localParams.parameter.country_chart = result.res_data.country
				credentials.localParams.parameter.CreateWorldMap()
				credentials.localParams.parameter.topCountryFunc(result.res_data.country)
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	
//===============================request otp=================================================
	[Const.RUN_REQUEST_OTP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_REQUEST_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.submitted = false
				credentials.localParams.parameter.email = ''
				credentials.localParams.parameter.otpScreen = true
				credentials.localParams.parameter.trans_id = result.res_data.trans_id
				credentials.localParams.parameter.lead_id = result.res_data.lead_id
				_messageDisplayFunction(credentials.localParams.parameter,'otp has been sent in your given email id','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_VERIFY_OTP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_VERIFY_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.lead_id){
					credentials.localParams.parameter.$router.replace({name: 'client.clientView', query: {'id':result.res_data.lead_id}})
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data.msg,'error')
				}
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},

	[Const.RUN_IB_REQUEST_OTP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_IB_REQUEST_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.submitted = false
				credentials.localParams.parameter.email = ''
				credentials.localParams.parameter.otpScreen = true
				credentials.localParams.parameter.trans_id = result.res_data.trans_id
				credentials.localParams.parameter.lead_id = result.res_data.lead_id
				_messageDisplayFunction(credentials.localParams.parameter,'otp has been sent in your given email id','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_IB_VERIFY_OTP]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_IB_VERIFY_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.lead_id){
					credentials.localParams.parameter.$router.replace({name: 'ib_view', query: {'id':result.res_data.lead_id}})
				}else{
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data.msg,'error')
				}
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_SEND_EMAIL_USER]({commit, state, dispatch,getters}, credentials){
		let API = Enpoints.EP_SEND_MAIL
		if(credentials.localParams.page && credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_IB_SEND_MAIL
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,'send mail successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	//manage-group===============================================
	[Const.RUN_GET_MANAGE_GROUP_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_MANAGE_GROUP_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.groupList =  result.res_data
			}else{
				credentials.localParams.parameter.groupList =  {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let msz = "create";
				if(credentials.globalParams.group_id){
					msz = "edit"
				}
				credentials.localParams.parameter.$router.push({ path: '/group-listing' })
				_messageDisplayFunction(credentials.localParams.parameter,msz+' manage group successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	
	//task===============================================
	[Const.RUN_GET_TASK_LIST]({commit, state, dispatch,getters}, credentials){
		let API = Enpoints.EP_GET_TASK_LIST
		if(credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_GET_IB_TASK_LIST
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.taskList =  result.res_data
			}else{
				credentials.localParams.parameter.taskList =  {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_ADD_TASK]({commit, state, dispatch,getters}, credentials){
		let API = Enpoints.EP_ADD_TASK
		if(credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_IB_ADD_TASK
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'add task successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_TASK_UPDATE_STATUS]({commit, state, dispatch,getters}, credentials){
		let API = Enpoints.EP_TASK_UPDATE_STATUS
		if(credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_IB_TASK_UPDATE_STATUS
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.listing()
				_messageDisplayFunction(credentials.localParams.parameter,'update status successfully','success')
			}else{
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	
	//===========================================================
	[Const.RUN_SEND_WITH_DATA]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_SEND_WITH_DATA,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let with_list = getters[Const.GET_WITHDRAWAL_LIST_MAKER];
				let withListArray = [];
				for(let i=0 ; i<=with_list.length-1 ; i++){
					if(credentials.localParams.parameter.roles.indexOf(with_list[i].id.toString()) == -1){
						withListArray.push(with_list[i])
					}
					if(i == with_list.length-1){
						if(withListArray.length == 0){
							credentials.localParams.parameter.record = false
							credentials.localParams.parameter.refetchRecordVar = true
						}else{credentials.localParams.parameter.refetchRecordVar = false}
						commit(Const.SET_WITHDRAWAL_LIST_MAKER, withListArray)
						credentials.localParams.parameter.roles = []
					}
				}
				_messageDisplayFunction(credentials.localParams.parameter,'Data Send successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	
	[Const.RUN_GET_WITHDRAWAL_LIST_MAKER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_LIST_MAKER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.refetchRecordVar = false
				commit(Const.SET_WITHDRAWAL_LIST_MAKER, result.res_data)
			}else{
				commit(Const.SET_WITHDRAWAL_LIST_MAKER, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_DOWNLOAD_FILES]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DOWNLOAD_FILES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//let with_doc_link = getters[Const.GET_WITHDRAWAL_DOC_LINK];
				let url = credentials.localParams.parameter.$env_var.withdrawalDocsLink+credentials.localParams.process_type+'&id='+result.res_data+'&doc='+result.res_data ;
				
				window.open(url,'_blank');
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
	[Const.RUN_GET_COUNTRIES_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COUNTRIES_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				

				commit(Const.SET_COUNTRIES_LIST, Object.values(result.res_data).map(value => { value.country = value.name; return value; }))
			}else{
				commit(Const.SET_COUNTRIES_LIST, {})
			}
		})
  	},
	
//====================================coupon================================================
	[Const.RUN_CREATE_COUPON]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_CREATE_COUPON,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'coupon create successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_COUPON_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COUPON_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COUPON_LIST, result.res_data)
			}else{
				commit(Const.SET_COUPON_LIST,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},

//====================================email=================================================
	[Const.RUN_EMAIL_SETTING_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_EMAIL_SETTING_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_EMAIL_SETTING_LIST, result.res_data)
			}else{
				commit(Const.SET_EMAIL_SETTING_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_ADD_EMAIL_SETTING]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_EMAIL_SETTING, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create email successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_GET_NOTIFICATION_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_NOTIFICATION_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.globalParams.read != undefined && !credentials.globalParams.read){
					commit(Const.SET_UNREAD_NOTIFICATION_DATA, result.res_data)
				}else{
					commit(Const.SET_ALL_NOTIFICATION_DATA, result.res_data)
					let inputJson = {
						'globalParams':{
							'page': "1",
							'perPage': 15,
							'read' : 0
						},
						'localParams' : {'parameter' : credentials.localParams.parameter}
					}
					dispatch(Const.RUN_GET_NOTIFICATION_LIST, inputJson);
				}
				
			}else{
				if(credentials.globalParams.read != undefined && !credentials.globalParams.read){
					commit(Const.SET_UNREAD_NOTIFICATION_DATA, [])
				}else{
					commit(Const.SET_ALL_NOTIFICATION_DATA, [])
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_GET_NOTIFICATION_OLD]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_NOTIFICATION_OLD_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_NOTIFICATION_OLD_LIST, result.res_data)
			}else{
				commit(Const.SET_NOTIFICATION_OLD_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================admin=================================================
	[Const.RUN_GET_ADMIN_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ADMIN_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.totalRecords > 0){
					for(let i=0 ; i<=result.res_data.records.length -1 ; i++){
						if(result.res_data.records[i].roles){
							result.res_data.records[i].role_array = result.res_data.records[i].roles.split(',')
						}else{
							result.res_data.records[i].role_array = []
						}
						
						if(i == result.res_data.records.length -1){
							//commit(Const.SET_ADMIN_LIST, result.res_data)

							if(credentials.localParams.pgeName){ 
								credentials.localParams.parameter.searchResult = result.res_data
							}else{
								commit(Const.SET_ADMIN_LIST, result.res_data)
							}

						}
					} 
				}else{
					//commit(Const.SET_ADMIN_LIST, result.res_data)
					if(credentials.localParams.pgeName){
						credentials.localParams.parameter.searchResult = {}
					}else{
						commit(Const.SET_ADMIN_LIST, [])
					}
				}
			}else{
				if(credentials.localParams.pgeName){
					credentials.localParams.parameter.searchResult = {}
					_messageDisplayFunction(credentials.localParams.parameter,'no rm found','error')
				}else{
					commit(Const.SET_ADMIN_LIST, [])
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}
				
				
			}
		}) 
  	},
	[Const.RUN_GET_ADMIN_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ADMIN_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_ADMIN_DETAIL, result.res_data[0])
			}else{
				commit(Const.SET_ADMIN_DETAIL, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_ADD_ADMIN]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_ADMIN, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create admin successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_UPDATE_ADMIN_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_UPDATE_ADMIN_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			credentials.localParams.parameter.showEditConfirm = '0'
			if(!error){
				if(credentials.localParams.pageName && credentials.localParams.pageName == 'rm_accuracy'){
					credentials.localParams.parameter.listing()
					credentials.localParams.parameter.reset()
				}else{
					if(credentials.localParams.type == 'email'){
						credentials.localParams.parameter.email = ''
						credentials.localParams.parameter.emailEdit = false
						credentials.localParams.parameter.detail()
					}else if(credentials.localParams.type == 'role'){
						credentials.localParams.parameter.role = []
						credentials.localParams.parameter.roleEdit = false
						credentials.localParams.parameter.detail()
					}else if(credentials.localParams.type == 'language'){
						credentials.localParams.parameter.language = []
						credentials.localParams.parameter.languageEdit = false
						credentials.localParams.parameter.detail()
					}else if(credentials.localParams.type == 'accuracy'){
						credentials.localParams.parameter.accuracy = ''
						credentials.localParams.parameter.accuracyEdit = false
						credentials.localParams.parameter.detail()
					}else if(credentials.localParams.type == 'password'){
						credentials.localParams.parameter.password = ''
						credentials.localParams.parameter.passwordEdit = false
						credentials.localParams.parameter.detail()
					}else if(credentials.localParams.type == 'name'){
						credentials.localParams.parameter.fname = ''
						credentials.localParams.parameter.lname = ''
						credentials.localParams.parameter.time_in = ''
						credentials.localParams.parameter.time_out = ''
						credentials.localParams.parameter.country = ''
						credentials.localParams.parameter.nameEdit = false
						credentials.localParams.parameter.detail()
					}else if(credentials.localParams.type == 'mobile'){
						credentials.localParams.parameter.mobile = ''
						credentials.localParams.parameter.mobileEdit = false
						credentials.localParams.parameter.detail()
					}else if(credentials.localParams.type == 'RM'){
						credentials.localParams.parameter.editRmList = {}
		                credentials.localParams.parameter.rm_type = ''
		                credentials.localParams.parameter.rmListName = []
		                credentials.localParams.parameter.listing()
					}
					
				}
				
				_messageDisplayFunction(credentials.localParams.parameter,'update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//=====================================faq==================================================
	[Const.RUN_CREATE_CATEGORY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_CATEGORY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.module == 'edit'){
					credentials.localParams.parameter.$router.push({ path: '/category-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'edit category successfully','success')
				}else{
					credentials.localParams.parameter.reset()
					_messageDisplayFunction(credentials.localParams.parameter,'create category successfully','success')
				}
			}else{
				if(credentials.localParams.module != 'edit'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CREATE_ARTICLE]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_ARTICLE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.module == 'edit'){
					credentials.localParams.parameter.$router.push({ path: '/articles-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'edit article successfully','success')
				}else{
					credentials.localParams.parameter.reset()
					_messageDisplayFunction(credentials.localParams.parameter,'create article successfully','success')
				}
			}else{
				if(credentials.localParams.module != 'edit'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ARTICLE_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ARTICLE_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_ARTICLE_LIST, result.res_data)
			}else{
				commit(Const.SET_ARTICLE_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_CAT_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_CAT_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_CAT_LIST, result.res_data)
			}else{
				commit(Const.SET_CAT_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ARTICLE_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_ARTICLE_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.art_name = result.res_data[0].articleName
				credentials.localParams.parameter.art_desc = result.res_data[0].description
				credentials.localParams.parameter.categoryId = result.res_data[0].categoryId
				credentials.localParams.parameter.category = result.res_data[0].catSlug
				credentials.localParams.parameter.status = result.res_data[0].status
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_CAT_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_CAT_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.cat_name = result.res_data[0].name
				credentials.localParams.parameter.cat_desc = result.res_data[0].description
				credentials.localParams.parameter.status = result.res_data[0].status
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_DELETE_ARTICLE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DELETE_ARTICLE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let msg = ((credentials.globalParams.status == 1)?'Enabled':'Disabled')+' Article Successfull'
				_messageDisplayFunction(credentials.localParams.parameter,msg,'success')
				credentials.localParams.parameter.listing()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_DELETE_CATEGORY]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DELETE_CATEGORY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let msg = ((credentials.globalParams.status == 1)?'Enabled':'Disabled')+' category Successfull'
				_messageDisplayFunction(credentials.localParams.parameter,msg,'success')
				credentials.localParams.parameter.listing()
			}else{
				
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================client=================================================
	[Const.RUN_WITHDRAWAL_METHODS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_WITHDRAWAL_METHODS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, result.res_data)
				let json ={} , count =0 ;
				for(var key in result.res_data){
					count++
					json[key] = {}
					let count1 = 0
					for(var innerkey in result.res_data[key]){
						count1++
						json[key][result.res_data[key][innerkey].id] = result.res_data[key][innerkey]
						if(count1 == Object.keys(result.res_data[key]).length){
							//console.log(json)
						}
					}
					if(count == Object.keys(result.res_data).length){
						commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE,json)
					}
				}
			}else{
				commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
//list and detail
	[Const.RUN_USER_COUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_COUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_USER_COUNT, result.res_data)
			}else{
				commit(Const.SET_USER_COUNT, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_RM_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_RM_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.pageName != undefined && credentials.localParams.pageName == 'rm_accuracy'){
					if(result.res_data.records && result.res_data.records.length > 0){
						credentials.localParams.parameter.rmAccuracyBulkUpdate(result.res_data.records)
					}
					credentials.localParams.parameter.rmAccuracy = result.res_data
				}else{
					credentials.localParams.parameter.searchresponse = true
					credentials.localParams.parameter.reporting_managet_list = result.res_data
				}
				
			}else{
				if(credentials.localParams.pageName != undefined && credentials.localParams.pageName == 'rm_accuracy'){
					credentials.localParams.parameter.rmAccuracy = {}
				}else{
					credentials.localParams.parameter.reporting_managet_list = []
					credentials.localParams.parameter.searchresponse = true
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_USER_LIST]({commit, state,getters,dispatch}, credentials){	
		let API = Enpoints.EP_GET_USER_LIST
		if(credentials.localParams.page && (credentials.localParams.page == 'IB-LIST' || credentials.localParams.page == 'ib-search')){
			API = Enpoints.EP_GET_IB_LIST
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.page == 'IB-LIST'){
					commit(Const.SET_IB_LIST, result.res_data)
				}else if(credentials.localParams.page == 'ib-search' || credentials.localParams.page == 'search'){
					credentials.localParams.parameter.searchData = result.res_data
				}else{
					commit(Const.SET_USER_LIST, result.res_data)
				}
			}else{
				if(credentials.localParams.page == 'IB-LIST'){
					commit(Const.SET_IB_LIST, [])
				}else if(credentials.localParams.page == 'ib-search' || credentials.localParams.page == 'search'){
					credentials.localParams.parameter.searchData = []
				}else{
					commit(Const.SET_USER_LIST, [])
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_IB_CHANGE_LIST]({commit, state, getters, dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_IB_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_IB_CHANGE_LIST, result.res_data)
			} else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_SUB_IB_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_SUB_IB_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_SUB_IB_LIST, result.res_data)
			}else{
				commit(Const.SET_SUB_IB_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_REMOVE_USER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_REMOVE_USER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'User deleted successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_LOGS_LIST]({commit, state,getters,dispatch}, credentials){
		let API = Enpoints.EP_GET_LOGS_LIST
		if(credentials.localParams.page && credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_GET_IB_LOGS_LIST
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOGS_LIST, result.res_data)
			}else{
				commit(Const.SET_LOGS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_LOGS_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_LOGS_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOGS_VIEW, result.res_data[0])
			}else{
				commit(Const.SET_LOGS_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_LOGS_DETAIL]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_LOGS_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.globalParams.type && credentials.globalParams.type != undefined){
					commit(Const.SET_EMAIL_DATA, result.res_data.details)
				}else{
					let logDataJsonArray = [] 
					credentials.localParams.parameter.logsDetailTab = '1'
					if(result.res_data.details.length > 0){
						for (var threadkey = 0; threadkey < result.res_data.details.length; threadkey++) {
							logDataJsonArray.push(JSON.parse(result.res_data.details[threadkey]))
							if(result.res_data.details.length-1 == threadkey){
								credentials.localParams.parameter.logsDetail = logDataJsonArray
							}
						}
					}else{
						credentials.localParams.parameter.logsDetail = []
					}
				}
			}else{
				if(credentials.globalParams.type && credentials.globalParams.type != undefined){
					commit(Const.SET_EMAIL_DATA, [])
				}else{
					credentials.localParams.parameter.logsDetail = []
					credentials.localParams.parameter.logsDetailTab = ''
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_EDIT_PAYMENT_METHODS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_EDIT_PAYMENT_METHODS,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.methodField = {}
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'Payment method has been updated succesfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_DISABLE_PAYMET_METHOD]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_DISABLE_PAYMET_METHOD,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.disableItem = {}
				credentials.localParams.parameter.detail()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_UPDATE_CLIENT_DETAIL]({commit, state,getters,dispatch}, credentials){	
		let API =''
		if(credentials.localParams.pagename && credentials.localParams.pagename == 'IB-VIEW'){
			API = Enpoints.EP_UPDATE_IB_DETAIL
		}else{
			API = Enpoints.EP_UPDATE_CLIENT_DETAIL
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			
			if(credentials.localParams.page == 'view'){  credentials.localParams.parameter.showEditConfirm = '0'  }
			
			if(!error){
				
				if(credentials.localParams.type == 'address'){
					credentials.localParams.parameter.addressEdit = false
					credentials.localParams.parameter.address1 = ''
					credentials.localParams.parameter.address2 = ''
					credentials.localParams.parameter.pincode = ''
					credentials.localParams.parameter.city = ''
					credentials.localParams.parameter.residence_country = ''
					credentials.localParams.parameter.nationality = ''
					credentials.localParams.parameter.addKey = false
				}else if(credentials.localParams.type == 'email'){
					credentials.localParams.parameter.emailEdit = false
                    credentials.localParams.parameter.email = ''
					credentials.localParams.parameter.emailKey = false
                }else if(credentials.localParams.type == 'financial'){
					credentials.localParams.parameter.financialEdit = false
                    credentials.localParams.parameter.emp_status = ''
                    credentials.localParams.parameter.occupation1 = ''
                    credentials.localParams.parameter.yearly_income = ''
                    credentials.localParams.parameter.net_worth = ''
                    credentials.localParams.parameter.account_turnover  = ''
					credentials.localParams.parameter.finKey = false					
                }else if(credentials.localParams.type == 'client'){
					credentials.localParams.parameter.clientEdit = false
                    credentials.localParams.parameter.fname = ''
                    credentials.localParams.parameter.mname = ''
                    credentials.localParams.parameter.lname = ''
                    credentials.localParams.parameter.mobile_no = ''
                    credentials.localParams.parameter.gender  = ''
                    credentials.localParams.parameter.dob    = ''
					credentials.localParams.parameter.clientKey = false					
                }else if(credentials.localParams.type == 'STEP'){
					credentials.localParams.parameter.step = ''
					credentials.localParams.parameter.stepEdit = false
					credentials.localParams.parameter.stepKey = false
				}else if(credentials.localParams.type == 'PRO_STATUS'){
					credentials.localParams.parameter.step = ''
					credentials.localParams.parameter.proEdit = false
					credentials.localParams.parameter.proUser = false
				}else if(credentials.localParams.type == 'RISKMETRIX'){
					credentials.localParams.parameter.identification = ''
					credentials.localParams.parameter.fund_source = ''
					credentials.localParams.parameter.deposit_method = ''
					credentials.localParams.parameter.credit_institution = ''
					credentials.localParams.parameter.channel_risk = ''
					credentials.localParams.parameter.third_party = ''
					credentials.localParams.parameter.otherKey = false
					credentials.localParams.parameter.otherEdit = false
				}else if(credentials.localParams.type == 'OTHER_INFO'){
					credentials.localParams.parameter.pep = ''
					credentials.localParams.parameter.sanction_risk = ''
					credentials.localParams.parameter.adverse_media = ''
					credentials.localParams.parameter.P_IDNUMBER = ''
					credentials.localParams.parameter.CRSNUMBER = ''
					credentials.localParams.parameter.tax_residency = ''
					credentials.localParams.parameter.id_type = ''
					credentials.localParams.parameter.otherInfoEdit = false
				}else if(credentials.localParams.type == 'LEAD_TYPE'){
					credentials.localParams.parameter.lead_type = ''
					credentials.localParams.parameter.submitted = false
					credentials.localParams.parameter.editLeadList = {}
				}else if(credentials.localParams.type == 'RM'){
					credentials.localParams.parameter.rm_type = ''
					credentials.localParams.parameter.submitted = false
					credentials.localParams.parameter.editRmList = {}
				}else if(credentials.localParams.type == 'Verify_date'){
					credentials.localParams.parameter.verifieDateEdit = false
					credentials.localParams.parameter.verifiedDate = ''
                 	credentials.localParams.parameter.closeDateEdit = false
                 	credentials.localParams.parameter.closeDate = ''
                }else if(credentials.localParams.type == 'role'){
					credentials.localParams.parameter.roleEdit = false
					credentials.localParams.parameter.role = []
                }else if(credentials.localParams.type == 'IB'){
					credentials.localParams.parameter.edittedAffliateList = '';
					credentials.localParams.parameter.ibid = null;
					credentials.localParams.parameter.IB = '';
                }

				if(credentials.localParams.page == 'view'){  
					credentials.localParams.parameter.detail() 
				}else{
					credentials.localParams.parameter.listing()
				}
				
				_messageDisplayFunction(credentials.localParams.parameter,'update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_USER_VIEW]({commit, state,getters,dispatch}, credentials){
		let API =''
		if(credentials.localParams.page && credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_GET_IB_VIEW
		}else{
			API = Enpoints.EP_GET_USER_VIEW
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.page == 'IB-VIEW'){
					commit(Const.SET_IB_VIEW, result.res_data[0])
					credentials.localParams.parameter.editPermissionFunc()
					if(credentials.localParams.page && credentials.localParams.page == 'createPdf'){
						credentials.localParams.parameter.$router.push({ path: '/clientpdf', query:{ "id" : credentials.globalParams.user_id } })
					}else{
						credentials.localParams.parameter.$router.push({ path: '/ib-view', query: { "id" : credentials.globalParams.user_id } })
					}
					if(credentials.localParams.ReturnBack){
		                 credentials.localParams.parameter.show_tab = credentials.localParams.ReturnBack
		            }
				}else{
					commit(Const.SET_USER_VIEW, result.res_data[0])
					if(credentials.localParams.ReturnBack){
		                 credentials.localParams.parameter.show_tab = credentials.localParams.ReturnBack
		         
		            }
					credentials.localParams.parameter.editPermissionFunc()
					if(credentials.localParams.page && credentials.localParams.page == 'createPdf'){
						credentials.localParams.parameter.$router.push({ path: '/clientpdf', query:{ "id" : credentials.globalParams.user_id } })
					}else{
						credentials.localParams.parameter.$router.push({ path: '/view', query: { "id" : credentials.globalParams.user_id } })
					}
				}
			}else{
				if(credentials.localParams.page == 'IB-VIEW'){
					commit(Const.SET_IB_VIEW, [])
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}else{
					commit(Const.SET_USER_VIEW, [])
					_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				}
			}
		}) 
  	},
	[Const.RUN_CLOSE_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		let API = Enpoints.EP_CLOSE_ACCOUNT
		if(credentials.localParams.Page && credentials.localParams.Page == 'IB-VIEW'){
			API = Enpoints.EP_IB_CLOSE_ACCOUNT
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'close account successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//reset password
  	[Const.RUN_RESET_PASSWORD]({commit, state,getters,dispatch}, credentials){
  		let API = Enpoints.EP_RESET_PASSWORD
		if(credentials.localParams.Page && credentials.localParams.Page == 'IB-VIEW'){
			API = Enpoints.EP_IB_RESET_PASSWORD
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.resetPasswordConfirm = false
				_messageDisplayFunction(credentials.localParams.parameter,'password reset successfully','success')
			}else{
				credentials.localParams.parameter.resetPasswordConfirm = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//create activity
  	[Const.RUN_CREATE_ACTIVITY]({commit, state,getters,dispatch}, credentials){
  		let API = Enpoints.EP_CREATE_ACTIVITY
		if(credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_CREATE_IB_ACTIVITY
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'create activity successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//get activity
  	[Const.RUN_GET_ACTIVITY]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ACTIVITY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_LOGS_LIST, result.res_data)
			}else{
				commit(Const.SET_LOGS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//verify account
  	[Const.RUN_VERIFY_ACCOUNT]({commit, state,getters,dispatch}, credentials){
  		let API = Enpoints.EP_VERIFY_ACCOUNT
		if(credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_IB_VERIFY_ACCOUNT
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.verifyAccount = false
				_messageDisplayFunction(credentials.localParams.parameter,'verify account successfully','success')
			}else{
				credentials.localParams.parameter.verifyAccount = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//disable
	[Const.RUN_DISABLE2FA]({commit, state,getters,dispatch}, credentials){
		let API = Enpoints.EP_DISABLE2FA
		if(credentials.localParams.page && credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_IB_DISABLE2FA
		}
		_executeApi(API,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.disable2Fa = false
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'disable 2FA successfully','success')
			}else{
				credentials.localParams.parameter.disable2Fa = false
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//notification
  	[Const.RUN_USER_NOTIFICATIONS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_USER_NOTIFICATIONS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//commit(Const.SET_USER_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({ path: '/view', query: { "id" : credentials.globalParams.user_id } })
			}else{}
		}) 
  	},
//internal note
  	[Const.RUN_ADD_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){
  		let API = Enpoints.EP_ADD_INTERNAL_NOTES
		if(credentials.localParams.page && credentials.localParams.page == 'IB-VIEW'){
			API = Enpoints.EP_IB_ADD_INTERNAL_NOTES
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'add internal note successfully','success')
			}else{
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_INTERNAL_NOTES]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_INTERNAL_NOTES, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_INTERNAL_NOTES, result.res_data)
			}else{
				commit(Const.SET_INTERNAL_NOTES, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//get risk metrix
	[Const.RUN_GET_RISK_METRIX]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_RISK_METRIX, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_RISK_METRIX, result.res_data)
			}else{
				commit(Const.SET_RISK_METRIX, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
	[Const.RUN_ALLOW_FOR_IPV]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ALLOW_FOR_IPV, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter,'ipv allow successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	//Internal tickets
	[Const.RUN_GET_INTERNAL_TICKET_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_INTERNAL_TICKET_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.internalList = result.res_data
			}else{
				credentials.localParams.parameter.internalList = {}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	  [Const.RUN_INTERNAL_TICKET_REASON]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_INTERNAL_TICKET_REASON, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TICKET_REASON_LIST, result.res_data)
				// credentials.localParams.parameter.internalReasonList = result.res_data
				// console.warn(credentials.localParams.parameter, "==========internalReasonList")
			}else{
				commit(Const.SET_TICKET_REASON_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================ticket=================================================
	[Const.RUN_GET_UPDATE_WITHDRAWAL_TICKET_TXNID]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_UPDATE_WITHDRAWAL_TICKET_TXNID, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'transaction id successfully added','success')
			} else{
				// console.log("2")
				// commit(Const.SET_TICKET_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
	},
	[Const.RUN_ADD_TICKET]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_TICKET, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.congModule = true
				credentials.localParams.parameter.$parent.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create ticket successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_TICKET_TRANSFER]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_TRANSFER, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.$router.push({ path: '/ticket-list' })
				_messageDisplayFunction(credentials.localParams.parameter,'ticket transfer successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CLOSE_TICKET]({commit, state,getters,dispatch}, credentials){
		let API;
		if(parseInt(credentials.localParams.reason) == 97){
  			API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
			//credentials.globalParams.status = '0' 
  		}else{
			API = Enpoints.EP_CLOSE_TICKET
		}
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.module == 'withdrawal'){
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.listing()
					_messageDisplayFunction(credentials.localParams.parameter,'reject data successfully','success')
				}else if(credentials.localParams.module == 'reject'){
					credentials.localParams.parameter.ticketDetail()
					credentials.localParams.parameter.reset()
					credentials.localParams.parameter.$router.push({ path: '/ticket-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'reject ticket successfully','success')
				}else{
					credentials.localParams.parameter.ticketDetail()
					credentials.localParams.parameter.$router.push({ path: '/ticket-list' })
					_messageDisplayFunction(credentials.localParams.parameter,'close ticket successfully','success')
				}
			}else{
				if(credentials.localParams.module == 'reject'){
					credentials.localParams.parameter.reset()
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TICKET_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TICKET_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TICKET_LIST, result.res_data)
			}else{
				commit(Const.SET_TICKET_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_TICKET_REASON_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_REASON_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TICKET_REASON_LIST, result.res_data)
			}else{
				commit(Const.SET_TICKET_REASON_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_TICKET_REQUEST_OTP]({commit, state,getters,dispatch}, credentials){	
  		credentials.localParams.parameter.submitted = false
		_executeApi(Enpoints.EP_TICKET_REQUEST_OTP, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.trans_id = result.res_data.trans_id
				if(credentials.localParams.type && credentials.localParams.type == 'pro'){
					credentials.localParams.parameter.show_step = ''
				}
			}else{
				if(credentials.localParams.type && credentials.localParams.type == 'pro'){
					credentials.localParams.parameter.show_step = ''
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_TICKET_RESEND_OTP]({commit, state,getters,dispatch}, credentials){	
  		credentials.localParams.parameter.submitted = false
		_executeApi(Enpoints.EP_TICKET_RESEND_OTP, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'suceessMsz18','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},

  	[Const.RUN_TICKET_CHECK_OTP]({commit, state,getters,dispatch}, credentials){	
  		let localParam = credentials.localParams
  		localParam.parameter.submitted = false
		localParam.parameter.$parent.submitted = false
		_executeApi(Enpoints.EP_TICKET_CHECK_OTP, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(parseInt(localParam.module) == 1 && parseInt(localParam.title) == 87){
					credentials.localParams.parameter.$parent.$parent.$parent.$parent.logout()
					//_messageDisplayFunction(credentials.localParams,'as you have changed your primary email , so please login again','success')
				}else if(parseInt(localParam.module) == 1  && parseInt(localParam.title) == 88){
					let get_user = getters[types.GET_USER]
					get_user.mobile_no = localParam.data
					commit(types.SET_STATE , get_user)
					
					var user = localStorage.getItem('user')
					user = atob(user)	;	user = JSON.parse(user)
					user.mobile_no = credentials.localParams.data										
					localStorage.setItem('user', btoa(JSON.stringify(user)))
					localParam.parameter.$parent.congModule = true
				}else if(credentials.localParams.data && credentials.localParams.data == 'pro'){
					credentials.localParams.parameter.$parent.show_step = ''
					localParam.parameter.$parent.congModule = true
				}else if(parseInt(localParam.module) == 16){  //pehle 93 tha 
					if(localParam.ticketRequestFrom == 'deposit'){
						localParam.parameter.$router.replace({ name: "fxView.deposit",params:{account_id_from_ticket:localParam.accountId}}) 
					}else if(localParam.ticketRequestFrom == 'profile'){
						localParam.parameter.$router.replace('/profile') 
						_messageDisplayFunction(credentials.localParams.parameter,'bank add successfully','success')
					}else if(localParam.ticketRequestFrom == 'profileOtp'){
						credentials.localParams.parameter.$parent.trans_id = '' 
						credentials.localParams.parameter.$parent.getUserProfileFunc()
						_messageDisplayFunction(credentials.localParams.parameter,'payment method disable successfully','success')
					}else{
						localParam.parameter.$parent.congModule = true
					}
				}else{
					localParam.parameter.$parent.congModule = true
				}

			}else{
				if(credentials.localParams.data && credentials.localParams.data == 'pro'){
					credentials.localParams.parameter.$parent.show_step = ''
				}
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},

  	[Const.RUN_GET_TICKET_REASON_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TICKET_REASON_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){

				let ticketData = _ticketFunction(result.res_data)
				commit(Const.SET_TICKET_DATA, ticketData)
				let count = 0
				for(var key in  result.res_data){
					//count++
					if(result.res_data[key].categories && result.res_data[key].categories != undefined && result.res_data[key].categories.length >0){
						let categoriesList = {}
						let innerCount = 0
						for(let i=0; i<= result.res_data[key].categories.length-1 ; i++){
							
							categoriesList[result.res_data[key].categories[i].id] = result.res_data[key].categories[i]
							innerCount++
							if(innerCount == result.res_data[key].categories.length){
								delete result.res_data[key].categories
								result.res_data[key]['categories'] = categoriesList
								count++
							}
						}
					}else{
						count++
					}
					if(count == Object.keys(result.res_data).length){
						commit(Const.SET_TICKET_REASON_LIST1, result.res_data)
						
					}
				}
				
			}else{
				commit(Const.SET_TICKET_REASON_LIST1, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TICKET_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TICKET_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let doc_array = [], i=0 ;
				if((typeof result.res_data.threads !== 'undefined') && (result.res_data.threads.length >0)){
					for (var threadkey = 0; threadkey < result.res_data.threads.length; threadkey++) {
						if(result.res_data.threads[threadkey].docs.length > 0){
							for (var dockey = 0; dockey < result.res_data.threads[threadkey].docs.length; dockey++) {
								doc_array.push(result.res_data.threads[threadkey].docs[dockey])
								if(parseInt(result.res_data.threads[threadkey].docs[dockey].status) == 0){
							    	i = 1
							  	}
							}
						}
					  	if(result.res_data.threads.length-1 == threadkey){
					  		if(i == 1){ 
						      result.res_data.approve_flag = false;
						    }else{ 
						      result.res_data.approve_flag = true;
						    }
							//console.log('result.res_data----',result.res_data)
						    commit(Const.SET_TICKET_VIEW, result.res_data)
						    commit(Const.SET_TICKET_DOCS, doc_array)
						}
					}
				}else{
					result.res_data.approve_flag = true;
					commit(Const.SET_TICKET_VIEW, result.res_data)
				    commit(Const.SET_TICKET_DOCS, doc_array)
				}
				//credentials.localParams.parameter.$router.push({ path: '/ticket-view', query: { "id" : credentials.globalParams.ticket_id } })
			}else{
				commit(Const.SET_TICKET_VIEW, [])
				commit(Const.SET_TICKET_DOCS, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_TICKET_REPLY]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_REPLY, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'message sent successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_TICKET_APPROVE]({commit, state,getters,dispatch}, credentials){
  		let API;
  		if(parseInt(credentials.localParams.from_ib) == 0){
  			if(parseInt(credentials.localParams.reason) == 91 || parseInt(credentials.localParams.reason) == 92 || parseInt(credentials.localParams.reason) == 94 ){
	  			API = Enpoints.EP_TICKET_APPROVE_USER
	  		}else if(parseInt(credentials.localParams.reason) == 97){
	  			API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
				credentials.globalParams.status = '1'
	  		}else{
	  			API = Enpoints.EP_TICKET_APPROVE
	  		}	
  		}else{
  			if(parseInt(credentials.localParams.reason) == 121){
	  			API = '/ib/approve'
	  		}else if(parseInt(credentials.localParams.reason) == 171 && parseInt(credentials.localParams.parameter.ticketView.ticket[0].title) == 0){
	  			API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
	  		}else{
	  			API = '/admin/ticket/ib/approve'
	  		}	
  		}
		// we need to move this with next build
		// if(parseInt(credentials.localParams.from_ib) == 1){ // we have reversed this condition in the case of from_ib is undefined and we get issue into approve ticket while we don't have from_ib
		// 	if(parseInt(credentials.localParams.reason) == 121){
		// 		API = '/ib/approve'
		// 	}else if(parseInt(credentials.localParams.reason) == 171 && parseInt(credentials.localParams.parameter.ticketView.ticket[0].title) == 0){
		// 		API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
		// 	}else{
		// 		API = '/admin/ticket/ib/approve'
		// 	}	
  		// }else{
		// 	if(parseInt(credentials.localParams.reason) == 91 || parseInt(credentials.localParams.reason) == 92 || parseInt(credentials.localParams.reason) == 94 ){
		// 		API = Enpoints.EP_TICKET_APPROVE_USER
		// 	}else if(parseInt(credentials.localParams.reason) == 97){
		// 		API = Enpoints.EP_EDIT_WITHDRAWAL_DETAILS
		// 	  credentials.globalParams.status = '1'
		// 	}else{
		// 		API = Enpoints.EP_TICKET_APPROVE
		// 	}	
  		// }
  		
		_executeApi(API, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				if(parseInt(credentials.localParams.from_ib) == 1){
					credentials.localParams.parameter.$router.push({ path: '/ib-ticket-list' })
				}else{
					credentials.localParams.parameter.$router.push({ path: '/ticket-list' })
				}
				
				_messageDisplayFunction(credentials.localParams.parameter,'ticket approve successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_TICKET_DOC_APPROVE_REJECT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_DOC_APPROVE_REJECT, credentials,credentials.localParams.parameter.$parent,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$parent.ticketDetail()
				_messageDisplayFunction(credentials.localParams.parameter,'documents successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_ESCALTE_TICKET]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_ESCALTE_TICKET, credentials,credentials.localParams.parameter.$parent,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.page == 'ticket_list'){
					credentials.localParams.parameter.roles = []
					credentials.localParams.parameter.listing()
					_messageDisplayFunction(credentials.localParams.parameter,'ticket escalate successfully','success')
				}else if(credentials.localParams.page == '2'){  
					credentials.localParams.parameter.ticketDetail() 
					_messageDisplayFunction(credentials.localParams.parameter,'ticket escalate successfully','success')
				}else{
					credentials.localParams.parameter.ticketDetail() 
					_messageDisplayFunction(credentials.localParams.parameter,'ticket deescalate successfully','success')
				}
				
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_TICKET_APPROVE_MULTIPLE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_TICKET_APPROVE_MULTIPLE, credentials,credentials.localParams.parameter.$parent,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.listing()
				credentials.localParams.parameter.roles = []
				_messageDisplayFunction(credentials.localParams.parameter,'ticket approve successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_GROUP_ADMIN_NAME]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_GROUP_ADMIN_NAME, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_GROUP_ADMIN_NAME, result.res_data)
				let count = 0 ;
				let json= {};
				if(Object.keys(result.res_data).length > 0){
					for(var key in result.res_data){
						count++
						for(let i=0 ; i<=result.res_data[key].length -1 ; i++){
							if((Object.keys(json).length == 0)  || !(json.hasOwnProperty(result.res_data[key][i].ID))){
								json[result.res_data[key][i].ID] = []
							}
							json[result.res_data[key][i].ID].push(key)
						}
						if(count == Object.keys(result.res_data).length){
							commit(Const.SET_USER_GROUP_ID, json)
						}
					}
				}else{
					commit(Const.SET_USER_GROUP_ID, [])
				}
				
				if(credentials.localParams.page == 'add-edit'){
					credentials.localParams.parameter.rmlistFunc()
				}
			}else{
				commit(Const.SET_GROUP_ADMIN_NAME, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================deposit================================================
	[Const.RUN_DEPOSIT_UPDATE_SUSPENSE]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DEPOSIT_UPDATE_SUSPENSE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.clearAll()
				_messageDisplayFunction(credentials.localParams.parameter,'deposit update successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_DEPOSIT_ASSIGN]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DEPOSIT_ASSIGN, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.clearAll()
				credentials.localParams.parameter.roles = []
				credentials.localParams.parameter.ticketReason1 = '114'
				credentials.localParams.parameter.tab = '2'
				credentials.localParams.parameter.listing()
				_messageDisplayFunction(credentials.localParams.parameter,'update Suspense Ticket Reason successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_DEPOSIT_UPLOAD]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_DEPOSIT_UPLOAD, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'deposit file upload successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_CREATE_DEPOSIT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_DEPOSIT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'create deposit successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_DEPOSIT_TRANSACTION_STATUS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_DEPOSIT_TRANSACTION_STATUS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.trans_hitory = result.res_data
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_DEPOSIT_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_DEPOSIT_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_DEPOSIT_LIST, result.res_data)
				// console.log(result.res_data.records[0].payment_status, "result.res_data==>>")
				// credentials.localParams.parameter.payment_status_val = result.res_data.records[0].payment_status
			}else{
				commit(Const.SET_DEPOSIT_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_DEPOSIT_VIEW]({commit, state,getters,dispatch}, credentials){		
		_executeApi(Enpoints.EP_GET_DEPOSIT_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_DEPOSIT_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({path: '/deposit-view',query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_DEPOSIT_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_EDIT_DEPOSIT_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_DEPOSIT_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
//====================================withdrawal=============================================
	[Const.RUN_ADD_WITHDRAWAL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_WITHDRAWAL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create withdrawal successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_ACCOUNT_DETAIL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_ACCOUNT_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.balance = result.res_data.balance
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_WITHDRAWAL_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WITHDRAWAL_LIST, result.res_data)
			}else{
				commit(Const.SET_WITHDRAWAL_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	
	[Const.RUN_GET_WITHDRAWAL_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_WITHDRAWAL_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({ path: '/withdrawal-view', query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_WITHDRAWAL_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_EDIT_WITHDRAWAL_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_WITHDRAWAL_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit,(error, result)=>{
			if(!error){
				credentials.localParams.parameter.edit_detail = false
			}
		}) 
  	},
  

  	
//====================================bonus=============================================
	[Const.RUN_GET_BONUS_LIST]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_BONUS_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_BONUS_LIST, result.res_data)
			}else{
				commit(Const.SET_BONUS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_BONUS_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_BONUS_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_BONUS_VIEW, result.res_data[0])
				//credentials.localParams.parameter.$router.push({ path: '/bonus-view', query: { "id" : credentials.globalParams.user_id } })
			}else{
				commit(Const.SET_BONUS_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_BONUS_DETAIL]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_BONUS_DETAIL, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.bonus = result.res_data.allowedBonus
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_ADD_BONUS]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_ADD_BONUS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'add bonus successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//====================================trading================================================
	[Const.RUN_CREATE_TRADING_ACCOUNT]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_CREATE_TRADING_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'create trading account successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TRADING_LIST]({commit, state,getters,dispatch}, credentials){
		_executeApi(Enpoints.EP_GET_TRADING_LIST, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_TRADING_LIST, result.res_data)
			}else{
				commit(Const.SET_TRADING_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_GET_TRADING_VIEW]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_GET_TRADING_VIEW, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				// console.log(result.res_data)
				result = result.res_data[0]
				// console.log(result)
				if(result.platform != 'ACT') {
					if(result.account_json && result.account_json.history && result.account_json.history.csv_array && result.account_json.history.csv_array.length) {
						result.account_json.history.csv_array.shift()
					}
					if(result.account_json && result.account_json.open_trades && result.account_json.open_trades.csv_array && result.account_json.open_trades.csv_array.length) {
						result.account_json.open_trades.csv_array.shift()
					}
					if(result.account_json && result.account_json.margin_detail && result.account_json.margin_detail.csv_array && result.account_json.margin_detail.csv_array.length) {
						result.account_json.margin_detail.csv_array.shift()
					}
				}
				commit(Const.SET_TRADING_VIEW, result)
				//credentials.localParams.parameter.$router.push({ path: '/trading-view', query: { "id" : credentials.globalParams.id } })
			}else{
				commit(Const.SET_TRADING_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_EDIT_TRADING_DETAILS]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_EDIT_TRADING_DETAILS, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.edit_detail = false
			}
		}) 
  	},
	[Const.RUN_CHANGE_LEVERAGE]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_CHANGE_LEVERAGE, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.leverageEdit = false
				credentials.localParams.parameter.editLeverageList = {}
				let tredingRecords = getters[Const.GET_TRADING_LIST];
				tredingRecords.records[credentials.localParams.parameter.edittedLeverageIndex].leverage = result.res_data.account.leverage;
				commit(Const.SET_TRADING_LIST, tredingRecords);
				credentials.localParams.parameter.edittedLeverageIndex = null;
				_messageDisplayFunction(credentials.localParams.parameter,'change leverage successfully','success');
				credentials.localParams.parameter.detail()
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	/*[Const.RUN_DELETE_TRADING_ACCOUNT]({commit, state,getters,dispatch}, credentials){	
		_executeApi(Enpoints.EP_DELETE_TRADING_ACCOUNT, credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//credentials.localParams.parameter.edit_detail = false
			}
		}) 
  	},*/

	[Const.RUN_GET_COMMISSION_TRADING_REPORT_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COMMISSION_TRADING_REPORT_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			credentials.localParams.parameter.innerPageLoader = false
			if(!error){
				// console.log('in result', result);
				// messageDisplayFunction(credentials.localParams.parameter,'Success','success');
				credentials.localParams.parameter.tradingCommisionList = result.res_data;
			}else{
				// console.log('in err', error);
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_GET_COMMISSION_REPORT_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COMMISSION_REPORT_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COMMISSION_REPORT_LIST,result.res_data)
			}else{
				commit(Const.SET_COMMISSION_REPORT_LIST,{})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_GET_COMMISSION_WITHDRAWAL_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COMMISSION_WITHDRAWAL_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COMMISSION_WITHDRAWAL_LIST,result.res_data)
			}else{
				commit(Const.SET_COMMISSION_WITHDRAWAL_LIST,{})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_GET_COMMISSION_REPORT_DETAIL]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_COMMISSION_REPORT_DETAIL,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(Const.SET_COMMISSION_REPORT_DETAIL,result.res_data)
			}else{
				commit(Const.SET_COMMISSION_REPORT_DETAIL,{})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_GET_UPLOADS_LIST]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_UPLOADS_LIST,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let arr = []
				if(result.res_data && (Object.keys(result.res_data).length)) {
					for(let key in result.res_data) {
						arr.push(result.res_data[key])
					}
				}
				commit(Const.SET_UPLOADS_LIST, arr)
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_UPDATE_LOYALTY_POINTS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.UPDATE_LOYALTY_POINTS,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'Success','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_GET_CLIENT_LEADS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.CLIENT_LEADS, credentials, credentials.localParams.parameter, {'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data) {
					commit(Const.SET_CLIENT_LEADS, result.res_data)
				}
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_REASSIGN_LEADS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_REASSIGN_LEADS,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'File Uploaded successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},


  	[Const.RUN_ADMIN_ADD_DEPOSIT_METHODS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADMIN_ADD_DEPOSIT_METHODS,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.listing()
				_messageDisplayFunction(credentials.localParams.parameter,'Add deposit method successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},


  	[Const.RUN_GET_ADMIN_DEPOSIT_METHODS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_GET_ADMIN_DEPOSIT_METHODS,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length > 0){
					credentials.localParams.parameter.select_method = (result.res_data.filter(val => parseInt(val.method) == parseInt(credentials.localParams.parameter.select_method))[0] || {}).id || ''
					credentials.localParams.parameter.changeValue()
				}
				commit(Const.SET_ADMIN_DEPOSIT_METHODS,result.res_data)
			}else{
				commit(Const.SET_ADMIN_DEPOSIT_METHODS,[])
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},


  	[Const.RUN_ADMIN_CHANGE_WITHDRAWAL_METHOD]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADMIN_CHANGE_WITHDRAWAL_METHOD,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,'Success','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_ADMIN_CHANGE_DEPOSIT_METHOD]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADMIN_CHANGE_DEPOSIT_METHOD,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				console.log(result, ">>>>>>>>>>>>>>>>....")
				credentials.localParams.parameter.reset()
				credentials.localParams.parameter.listing()
				_messageDisplayFunction(credentials.localParams.parameter,'Change deposit method successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_LOYALITY_POINT_COUNT]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.GET_LOYALITY_POINT_COUNT,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(result.res_data.length > 0){
					commit(Const.SET_LOYALITY_POINT_COUNT,result.res_data[0])
				}else{
					commit(Const.SET_LOYALITY_POINT_COUNT,{})
				}
			}else{
				commit(Const.SET_LOYALITY_POINT_COUNT,{})
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_CHANGE_ACCOUNT_LIMIT]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_CHANGE_ACCOUNT_LIMIT,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,'Change account limit successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_CHANGE_ACCOUNT_TYPE]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_CHANGE_ACCOUNT_TYPE,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				// credentials.localParams.parameter.closeModal()
				credentials.localParams.parameter.$parent.detail();
				_messageDisplayFunction(credentials.localParams.parameter,'Change account type successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_UPDATE_WITHDRAWAL_DETAILS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_UPDATE_WITHDRAWAL_DETAILS,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,'Withdrawal ticket updated successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
	  [Const.RUN_UPDATE_DEPOSIT_DETAILS]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_UPDATE_DEPOSIT_DETAILS,credentials,credentials.localParams.parameter,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.closeModal()
				_messageDisplayFunction(credentials.localParams.parameter,'Deposit ticket updated successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
}

//------------------------------------------------------Functions------------------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
 	commit("SET_INFO", msg)
}
function _handleErrorResponse(e, commit) {
  	let response = {info: 'NOK', msg: 'Service not available'}
  	if (typeof e.response === 'undefined') {
    	try {
      		const statusCheck = e.toString().toLowerCase()
	      	if (statusCheck.indexOf('network') > -1) {
	        	response = {info: 'NOK', msg: 'Network Error'}
	      	}
    	} catch (e) {}
  	} else {
    	response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if(typeof e.response !== 'undefined'){
		if(e.response.status == 401){
 			let data = {}
			let options = {}
			options.forward = true
	 		_handleLogout(data, commit, options)
	 	}
	}
}
function _handleLogout (data, commit, options) {
	let user = {}
	const state = []
	window.sessionStorage.setItem('user_info', "")
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.replace("/")
	}
}

function _downloadReport(arrData , getFileName, getType){
	var csv = '';
	if(getType == 'card'){
		csv = 'Username,Email,Level,Issued Points,Used Points';
	}else if(getType == 'transaction'){
		csv = 'Username,Email,Date,Activity,Volume,Points,Cr/Db';
	}
	csv += "\n";
	arrData.forEach(function(row) {
		if(getType == 'card'){
			csv += row.username+","+row.email+","+row.level+","+row.issued_points+","+row.used_points
		}else if(getType == 'transaction'){
			let transactionType = { 1 : "credit", 2 : "debit" };
			csv += row.username+","+row.email+","+moment(row.created).format(" DD MMM YYYY")+","+row.activity+","+row.volume+","+row.points+","+transactionType[parseInt(row.transaction_type)]
		}
		csv += "\n";
	});
	var hiddenElement = document.createElement('a');
	hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
	hiddenElement.target = '_blank';
	hiddenElement.download = getFileName;
	hiddenElement.click();


	// let csvContent = "data:text/csv;charset=utf-8,";
	// csvContent += [
	// Object.keys(arrData[0]).join(","),
	// ...arrData.map(item => Object.values(item).join(","))
	// ]
	// .join("\n")
	// .replace(/(^\[)|(\]$)/gm, "");
	// const data = encodeURI(csvContent);
	// const link = document.createElement("a");
	// link.setAttribute("href", data);
	// link.setAttribute("download", getFileName);
	// link.click();
}

function _executeApi (apiLink, credentials,getLoaderParams,getToken,commit, callback) {
	try{
		let response_array = [];
		if(credentials.localParams.module == 'ticket-reply' || credentials.localParams.module == 'korapay_file_upload'){ credentials.globalParams = credentials.globalParams.form }
		else if(credentials.localParams.type == 'form'){ credentials.globalParams = credentials.globalParams.form }
		
		if(credentials.localParams.pgeName && credentials.localParams.pgeName == 'adminList'){
			getLoaderParams.pageLoader1 = true
		}else{
			getLoaderParams.pageLoader = true
		}
		
		//console.log(Enpoints.BASE_URL+apiLink)
		RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams,getToken)
		.map(response => response.data)
		.subscribe(data => 
		{
			if(credentials.localParams.pgeName && credentials.localParams.pgeName == 'adminList'){
				getLoaderParams.pageLoader1 = false
			}else{
				getLoaderParams.pageLoader = false
			}
			if ('info' in data){
				if (data.info === 'OK') {
					response_array.res_data = data.data 
					callback(false, response_array)
				}
				else{
					response_array.res_data = data.msg
					callback(true, response_array)
				}
			}
		},
		e => {	_handleErrorResponse(e, commit)	}) 
	}catch(ex){	_handleErrorResponse(ex, commit) }
}

function _messageDisplayFunction(getParameter,getMessage,msgType){
	getParameter.$notify({
		group: 'foo',
		type : msgType,
		text: getMessage,
		duration: 10000,
		closeOnClick : true
	});
}

function _ticketFunction(respData){
	// priority basis keys 
	//parent  ['1', '3', '4', '2']
	const getResponseData = respData
	let keyByPriortity = []
	let obj = {}
	let count = 0
	for(var key in  getResponseData){
		const parent_id = getResponseData[key].id
		keyByPriortity[getResponseData[key].priority] = parent_id
		obj["-1"] = keyByPriortity
		
		let childCount = 0
		count++
		const child = getResponseData[key].categories
		//console.log(child)
		if(child){
			let childPriority = []
			for(var i=0; i <= child.length-1; i++){
				const children = child[i]
				childPriority[children.priority] = children.id
				childCount++
				if(i ==  child.length-1){
					//empty
					var filtered = childPriority.filter(function (el) {
					  return el != null && el != '';
					});
					obj[parent_id] = filtered
				}
				if(i== child.length-1 && count == Object.keys(getResponseData).length){
					var childfiltered = keyByPriortity.filter(function (el) {
					  return el != null && el != '';
					});
					obj["-1"]= childfiltered
					return obj
				}
			}
		}else{
			if(count == Object.keys(getResponseData).length){
				var childfiltered = keyByPriortity.filter(function (el) {
				  return el != null && el != '';
				});
				obj["-1"]= childfiltered
				return obj;
			}
		}
		
	}
}




// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/actions.js